import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { whatsappLink } from "@/lib/config";
import { InstallAppButton } from "@/components/InstallAppButton";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { label: "Serviços", href: "#servicos" },
    { label: "Benefícios", href: "#beneficios" },
    { label: "Galeria", href: "#galeria" },
    { label: "Contato", href: "#contato" },
  ];

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#050505]/80 border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-5 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-baseline gap-2">
          <span className="font-heading text-2xl md:text-3xl font-light text-[#FAFAFA] tracking-tight">
            EZ <span className="gold-gradient-text italic">Capelli</span>
          </span>
          <span className="overline hidden md:inline-block">Studio</span>
        </a>

        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm tracking-wide text-[#FAFAFA]/75 hover:text-[#D4AF37] transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            data-testid="nav-whatsapp-btn"
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary-gold text-xs"
          >
            Agendar
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-[#D4AF37]"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden border-t border-white/5 bg-[#050505]/95 backdrop-blur-xl"
        >
          <div className="flex flex-col px-6 py-6 gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-link-${l.label.toLowerCase()}`}
                className="text-base text-[#FAFAFA]/85 hover:text-[#D4AF37]"
              >
                {l.label}
              </a>
            ))}
            <a
              data-testid="mobile-whatsapp-btn"
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary-gold text-xs justify-center"
            >
              Agendar pelo WhatsApp
            </a>
            <InstallAppButton />
          </div>
        </div>
      )}
    </nav>
  );
}
